<script setup lang="ts"></script>

<template>
  <div>
    <div class="px-bleed flex flex-col gap-4 py-10">
      <h1 class="mb-5 text-center text-2xl uppercase">Design tokens</h1>

      <h2 class="mt-10 text-center text-sm uppercase">Text sizes</h2>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">XS</div>
        <p class="line-clamp-1 text-xs">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">SM</div>
        <p class="line-clamp-1 text-sm">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">BASE</div>
        <p class="line-clamp-1 text-base">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">LG</div>
        <p class="line-clamp-1 text-lg">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">XL</div>
        <p class="line-clamp-1 text-xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">2XL</div>
        <p class="line-clamp-1 text-2xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">3XL</div>
        <p class="line-clamp-1 text-3xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">4XL</div>
        <p class="line-clamp-1 text-4xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">5XL</div>
        <p class="line-clamp-1 text-5xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">6XL</div>
        <p class="line-clamp-1 text-6xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">7XL</div>
        <p class="line-clamp-1 text-7xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <h2 class="mt-10 text-center text-sm uppercase">Fonts</h2>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">Sans serif</div>
        <p class="line-clamp-1 font-sans text-2xl">The quick brown fox jumps over the lazy dog</p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">Mono</div>
        <p class="line-clamp-1 font-mono text-2xl uppercase">
          The quick brown fox jumps over the lazy dog
        </p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">Display</div>
        <p class="font-display line-clamp-1 text-2xl uppercase">
          The quick brown fox jumps over the lazy dog
        </p>
      </div>

      <div class="rounded-md bg-zinc-100 p-3">
        <div class="mb-2 text-xs font-bold text-zinc-400">Display Extended</div>
        <p class="font-display line-clamp-1 text-2xl uppercase font-stretch-expanded">
          The quick brown fox jumps over the lazy dog
        </p>
      </div>

      <h2 class="mt-10 text-center text-sm uppercase">Colors</h2>

      <div
        class="grid gap-5 rounded-2xl bg-zinc-100 bg-[linear-gradient(to_right,dodgerblue_1px,transparent_1px),linear-gradient(to_bottom,dodgerblue_1px,transparent_1px)] bg-[size:24px_24px] bg-[position:-2px_-10px] p-5"
      >
        <div class="bg-neon-yellow h-50 w-full rounded-xl p-5">Neon yellow</div>
        <div class="h-50 w-full rounded-xl bg-black p-5 text-white">Black</div>
        <div class="bg-dark-grey h-50 w-full rounded-xl p-5 text-white">Dark grey</div>
        <div class="bg-light-grey h-50 w-full rounded-xl p-5">Light grey</div>
        <div class="h-50 w-full rounded-xl bg-white p-5">White</div>
        <div class="bg-neon-yellow/60 h-50 w-full rounded-xl p-5">Neon yellow 60%</div>
        <div class="h-50 w-full rounded-xl bg-black/50 p-5 text-white">Black 50%</div>
        <div class="h-50 w-full rounded-xl bg-white/50 p-5">White 50%</div>
        <div class="h-50 w-full rounded-xl p-5 backdrop-blur-[20px]">Blur 20px</div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>
